import Data from '../../data/main/config/setup/form/forms'

const state = {
  formType: Data.forms.rechteck.type[0].name,
  formTypeCode: Data.forms.rechteck.type[0].code,
  formSize: {
    a: null,
    b: null
  },
  formSizeHelperReset: false,
  formImage: Data.forms.rechteck.type[0].cartImg,
  formTabIndex: 0,
  formSelected: Array(Object.keys(Data.forms).length).fill(0)
}

const mutations = {
  'SET_FORM_TYPE' (state, form) {
    state.formType = form.type
    state.formTypeCode = form.code
    state.formImage = form.img
  },
  'SET_FORM_SIZE' (state, side) {
    state.formSize[side.name] = parseFloat(side.value)
  },
  'SET_FORM_TABINDEX' (state, value) {
    state.formTabIndex = value
  },
  'INIT_FORM_SIZE' (state, sideNames) {
    state.formSize = {}
    for (var side in sideNames) {
      state.formSize[side] = null
    }
  },
  'CLEAR_FORM' (state) {
    state.formType = Data.forms.rechteck.type[0].name
    state.formTypeCode = Data.forms.rechteck.type[0].code
    state.formSize = {
      a: null,
      b: null
    }
    state.formImage = Data.forms.rechteck.type[0].cartImg
    state.formTabIndex = 0
    state.formSizeHelperReset = true
  },
  'UPDATE_FORMSELECTED' (state, update) {
    state.formSelected[update.index] = update.value
  },
  'RESET_FORMSELECTED' (state) {
    state.formSelected.fill(0)
  },
  'CHANGE_FORMSIZEHELPERRESET' (state) {
    state.formSizeHelperReset = false
  }
}

const actions = {
  setFormType: ({ commit }, form) => {
    commit('SET_FORM_TYPE', form)
  },
  setFormSize: ({ commit }, side) => {
    commit('SET_FORM_SIZE', side)
  },
  setFormTabIndex: ({ commit }, value) => {
    commit('SET_FORM_TABINDEX', value)
  },
  initFormSize: ({ commit }, sideNames) => {
    commit('INIT_FORM_SIZE', sideNames)
  },
  clearForm: ({ commit }) => {
    commit('CLEAR_FORM')
  },
  updateFormSelected: ({ commit }, update) => {
    commit('UPDATE_FORMSELECTED', update)
  },
  resetFormSelected: ({ commit }) => {
    commit('RESET_FORMSELECTED')
  },
  changeFormSizeHelperReset: ({ commit }) => {
    commit('CHANGE_FORMSIZEHELPERRESET')
  }
}

const getters = {
  formType: state => {
    return state.formType
  },
  formTypeCode: state => {
    return state.formTypeCode
  },
  formSize: state => {
    return state.formSize
  },
  formImage: state => {
    return state.formImage
  },
  formTabIndex: state => {
    return state.formTabIndex
  },
  formSelected: state => {
    return state.formSelected
  },
  formSizeHelperReset: state => {
    return state.formSizeHelperReset
  },
  activeFormHohlschnitt: state => {
    return (state.formType === Data.forms.dreieck.type[0].name || state.formType === Data.forms.dreieck.type[1].name || state.formType === Data.forms.dreieck.type[2].name || state.formType === Data.forms.rechteck.type[0].name || state.formType === Data.forms.trapez.type[0].name)
  },
  activeFormKeder: state => {
    return (state.formType === Data.forms.dreieck.type[0].name || state.formType === Data.forms.dreieck.type[1].name || state.formType === Data.forms.dreieck.type[2].name || state.formType === Data.forms.rechteck.type[0].name || state.formType === Data.forms.trapez.type[0].name || state.formType === Data.forms.trapez.type[1].name || state.formType === Data.forms.trapez.type[2].name || state.formType === Data.forms.trapez.type[3].name || state.formType === Data.forms.trapez.type[4].name || state.formType === Data.forms.trapez.type[5].name || state.formType === Data.forms.trapez.type[6].name)
  },
  activeKreis: state => {
    return state.formType === Data.forms.kreis.type[0].name
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
